import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Skeleton } from "../../base/skeleton/skeleton";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../base/table/table";
/**
 * Skeleton loading state for DataTable component.
 * Displays placeholder rows while data is being fetched.
 *
 * @example
 * ```tsx
 * <DataTableSkeleton columnCount={5} rowCount={10} />
 * ```
 */ export function DataTableSkeleton({ columnCount = 5, rowCount = 5, showPagination = true, className }) {
    return /*#__PURE__*/ _jsxs("div", {
        className: className,
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "rounded-md border",
                children: /*#__PURE__*/ _jsxs(Table, {
                    children: [
                        /*#__PURE__*/ _jsx(TableHeader, {
                            children: /*#__PURE__*/ _jsx(TableRow, {
                                children: Array.from({
                                    length: columnCount
                                }).map((_, index)=>/*#__PURE__*/ _jsx(TableHead, {
                                        children: /*#__PURE__*/ _jsx(Skeleton, {
                                            className: "h-4 w-full"
                                        })
                                    }, index))
                            })
                        }),
                        /*#__PURE__*/ _jsx(TableBody, {
                            children: Array.from({
                                length: rowCount
                            }).map((_, rowIndex)=>/*#__PURE__*/ _jsx(TableRow, {
                                    children: Array.from({
                                        length: columnCount
                                    }).map((_, cellIndex)=>/*#__PURE__*/ _jsx(TableCell, {
                                            children: /*#__PURE__*/ _jsx(Skeleton, {
                                                className: "h-4 w-full"
                                            })
                                        }, cellIndex))
                                }, rowIndex))
                        })
                    ]
                })
            }),
            showPagination && /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center justify-between px-2 py-4",
                children: [
                    /*#__PURE__*/ _jsx(Skeleton, {
                        className: "h-8 w-40"
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex items-center space-x-6 lg:space-x-8",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "flex items-center space-x-2",
                                children: [
                                    /*#__PURE__*/ _jsx(Skeleton, {
                                        className: "h-8 w-24"
                                    }),
                                    /*#__PURE__*/ _jsx(Skeleton, {
                                        className: "h-8 w-[70px]"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Skeleton, {
                                className: "h-8 w-[100px]"
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "flex items-center space-x-2",
                                children: [
                                    /*#__PURE__*/ _jsx(Skeleton, {
                                        className: "h-8 w-8"
                                    }),
                                    /*#__PURE__*/ _jsx(Skeleton, {
                                        className: "h-8 w-8"
                                    }),
                                    /*#__PURE__*/ _jsx(Skeleton, {
                                        className: "h-8 w-8"
                                    }),
                                    /*#__PURE__*/ _jsx(Skeleton, {
                                        className: "h-8 w-8"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

//# sourceMappingURL=DataTableSkeleton.js.map